import { ComponentProps, ReactNode } from 'react';
import { Box, ButtonV2, Text } from '@bridebook/ui';
import { styles } from './intercept-modal-content.style';

export type InterceptModalContentProps = {
  title: string;
  text?: string | ReactNode;
  primaryButtonProps?: ComponentProps<typeof ButtonV2>;
  secondaryButtonProps?: ComponentProps<typeof ButtonV2>;
  image?: ReactNode;
};

export const InterceptModalContent = ({
  title,
  text,
  primaryButtonProps,
  secondaryButtonProps,
  image,
}: InterceptModalContentProps) => (
  <Box style={styles.wrapper}>
    <Box style={styles.contentWrapper}>
      {image && <Box style={styles.imageWrapper}>{image}</Box>}
      <Box style={styles.title}>{title}</Box>
      {text && <Text style={styles.text}>{text}</Text>}
    </Box>

    <Box style={styles.buttonGroup}>
      <ButtonV2 {...primaryButtonProps} />
      <ButtonV2 variant="secondary" {...secondaryButtonProps} />
    </Box>
  </Box>
);
